<!--
 * @Date: 2019-09-02 14:51:45
 * @LastEditTime: 2021-07-02 16:18:34
 -->
<template>
  <div class="uploader" ref="uploader" :id="containerId">
    <div
      class="sy-upload-trigger"
      :class="{
        'sy-upload--picture-card': listType != 'text',
        'sy-upload--picture-card-disabled': listType === 'picture-card' && uploadDisabled
      }"
      :id="selectFileId">
      <slot name="trigger"></slot>
      <slot></slot>
    </div>
    <upload-list
      v-if="showFileList && listType === 'picture-card'"
      :files="files"
      :disabled="uploadDisabled"
      :listType="listType"
      :handlePreview="onPreview"
      @remove="handleRemove"
      @cancel="handleCancel"
    ></upload-list>
    <slot name="tip"></slot>
    <upload-list
      v-if="showFileList && listType !== 'picture-card'"
      :files="files"
      :disabled="uploadDisabled"
      :listType="listType"
      :handlePreview="onPreview"
      @remove="handleRemove"
    ></upload-list>
  </div>
</template>

<script>
  import plupload from 'plupload'
  import UploadList from './upload-list'
  import uploadApi from './common/apis'
  // import SparkMD5 from 'spark-md5'
  import qs from 'qs'
  import axios from 'axios'
  import Store from '../../../common/catch-state/store'
  import Model from './common/cache-model'
  import { accessorySystemType } from '../../../common/constants'
  import { AcceptTypes } from './common/constans'
  import i18n from './i18n.js'
  const pageText = window.fe.getPageText(i18n)

  Store.install(Model)

  const FLASH_URL = IS_DEV ? './flash/Moxie.swf' : './supplier_web/supplier_web.config/flash/Moxie.swf'
  const SILVERLIGHT_URL = IS_DEV ? './silverligh/Moxie.xap' : './supplier_web/supplier_web.config/silverligh/Moxie.xap'
  
  function noop () {}

  export default {
    props: {
      // 上传url
      action: {
        type: String,
        required: true
      },
      // 请求头携带参数
      headers: {
        type: Object,
        default: () => ({})
      },
      // 请求内容携带参数
      data: {
        type: Object,
        default: () => ({})
      },
      // 是否多选
      multiple: Boolean,
      // 上传文件字段名称
      name: {
        type: String,
        default: 'file'
      },
      // 是否显示上传列表
      showFileList: {
        type: Boolean,
        default: true
      },
      // 上传类型
      accept: String,
      // 上传类型
      acceptType: {
        type: String,
        default: 'FILE' // IMAGE
      },
      beforeUpload: Function,
      beforeRemove: Function,
      onRemove: {
        type: Function,
        default: noop
      },
      onChange: {
        type: Function,
        default: noop
      },
      onPreview: {
        type: Function
      },
      onSuccess: {
        type: Function,
        default: noop
      },
      onProgress: {
        type: Function,
        default: noop
      },
      onError: {
        type: Function,
        default: noop
      },
      onExceed: {
        type: Function,
        default: noop
      },
      // 文件列表
      fileList: {
        type: Array,
        default: () => []
      },
      // 是否自动发起上传
      autoUpload: {
        type: Boolean,
        default: true
      },
      // 文件列表的类型
      listType: {
        type: String,
        default: 'text' // text,picture,picture-card
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false
      },
      // 最大上传数量
      limit: {
        type: Number,
        default: 5
      },
      // 上传文件最大体积
      maxFileSize: {
        type: String,
        default: '5mb'
      },
      // 是否开启切片上传
      isChunk: {
        type: Boolean,
        default: false
      },
      // 业务代码
      business: {
        type: String,
        default: null
      },
      // 拓展参数
      extend: {
        type: [String, Object],
        default: null
      },
      /*
        访问权限
        def 默认，open 公开访问，notopen 私有访问
        def 图片文件公开访问，非图片文件私有访问
      */
      permission: {
        type: String,
        default: 'def'
      },
      // 文件类型
      fileType: {
        type: String,
        default: 'file'
      },
      // zip包内单个文件大小限制
      inZipMaxSize: {
        type: [String, Number]
      },
      // paas校验规则
      checkRule: String
    },
    components: {
      UploadList
    },
    data () {
      return {
        // 系统标识
        system: accessorySystemType,
        // 容器id
        containerId: `upload-container__${this.guid()}`,
        // 选中文件id
        selectFileId: `plupload_selectFile__${this.guid()}`,
        tempIndex: 1,
        // 文件信息列表
        uploadFileInfos: [],
        files: [],
        pageText
      }
    },
    computed: {
      uploadDisabled () {
        return this.disabled
      },
      // 文件大小转换为字节大小
      sizeConvert () {
        let byte = 0
        if (this.inZipMaxSize) {
          const isKb = this.inZipMaxSize.toLowerCase().indexOf('kb') > -1
          const isMb = this.inZipMaxSize.toLowerCase().indexOf('mb') > -1
          const isGb = this.inZipMaxSize.toLowerCase().indexOf('gb') > -1
          if (typeof this.inZipMaxSize === 'number') {
            return this.inZipMaxSize
          } else if (typeof this.inZipMaxSize === 'string') {
            if (isKb) {
              const kbIndex = this.inZipMaxSize.toLowerCase().indexOf('kb')
              byte = this.inZipMaxSize.slice(0, kbIndex) * 1024
              return isNaN(byte) ? 0 : byte
            } else if (isMb) {
              const mbIndex = this.inZipMaxSize.toLowerCase().indexOf('mb')
              byte = this.inZipMaxSize.slice(0, mbIndex) * (1024 * 1024)
              return isNaN(byte) ? 0 : byte
            } else if (isGb) {
              const gbIndex = this.inZipMaxSize.toLowerCase().indexOf('gb')
              byte = this.inZipMaxSize.slice(0, gbIndex) * (1024 * 1024 * 1024)
              return isNaN(byte) ? 0 : byte
            } else {
              return byte
            }
          }
        } else {
          return byte
        }
      }
    },
    mounted () {
      if (!this.accept) {
        this.accept = AcceptTypes[this.acceptType] || ''
      }
      this._initUploader()
    },
    watch: {
      fileList: {
        immediate: true,
        handler (fileList) {
          this.files = fileList.map(item => {
            item.uid = item.uid || (Date.now() + this.tempIndex++)
            item.status = item.status || 'success'
            item.name = item.name || item.originalName
            return item
          })
          this.uploadFileInfos = this.uploadFileInfos.filter(file => {
            const item = this.fileList.find(item => item.id === file.id)
            if (item) return item
          })
        }
      },
      disabled: {
        immediate: true,
        handler (disabled) {
          if (disabled) {
            this.uploader && this.uploader.disableBrowse(true)
          } else {
            this.uploader && this.uploader.disableBrowse(false)
          }
        }
      },
      action () {
        // 动态修改action
        !this.isChunk && this.uploader.setOption('url', this.action)
      }
    },
    methods: {
      s4 () {
        return ((1 + Math.random()) * 0x10000 || 0).toString(16).substring(1)
      },
      guid () {
        return (
          this.s4() +
          Date.now() +
          Math.floor(Math.random() * 999999)
        ).replace(new RegExp('\\.', 'gm'), '')
      },
      // 选取文件 change
      async handleChange (up, fileList) {
        if (this.isChunk) {
          await this._getToken()
          if (this.userinfo) {
            this._uploadFiles(up, fileList)
          }
        } else {
          this._uploadFiles(up, fileList)
        }
      },
      // 获取临时令牌
      async _getToken () {
        let res = await Store.upload('getToken').getter({api: uploadApi.uploadAuth, system: this.system})
        if (res.isOk) {
          this.userinfo = res.content
        }
        // this.userinfo = await GetAccessoryToken(uploadApi.uploadAuth, this.system) || ''
      },
      handleUploadProgress (up, file) {
        const files = this._getFile(file)
        if (files) {
          this.onProgress(up.total, files, this.fileList)
          files.status = 'uploading'
          files.percentage = up.total.percent || 0
        }
      },
      async handleUploadSuccess (up, file, resObj) {
        const res = JSON.parse(resObj.response)
        if (this.isChunk && !res.success) {
          this.$message.error(res.errorMessage)
          this.handleRemove(file)
          return false
        }

        let result = null
        if (this.isChunk) {
          if (!this.uploadFileInfos.find(item => item.id === file.id)) {
            return false
          }
          const { token } = this.uploadFileInfos.find(item => item.id === file.id)
          result = await this._complete(token, file)
          // 文件合并失败
          if (!result) return false
        } else {
          result = res
        }
        let files = this._getFile(file)
        if (files) {
          // TODO 重写返回参数
          files.status = 'success'
          delete files.raw
          delete files.percentage

          const response = this.isChunk && result && result.success ? result : JSON.parse(resObj.response)
          response.imgUrl = this.isChunk ? response.content.openUrl : null
          if (response.code === 'success' && response.success) {
            this.onSuccess(response, files, this.fileList)
            this.onChange(files, this.fileList)
          } else {
            this.handleUploadError(up, {
              file: file,
              code: -200,
              response: response,
              errorMessage: response.errorMessage
            })
          }
        }
      },
      handleUploadError (up, errObj, errMsg = true) {
        if (errObj.code === -200) {
          const files = this._getFile(errObj.file)
          const fileList = this.fileList
          if (files) {
            files.status = 'fail'
            if (fileList.indexOf(files) > -1) {
              fileList.splice(fileList.indexOf(files), 1)
            }
            if (errObj.response) {
              this.onError(errObj.response, files, this.fileList)
            }
            this.onChange(files, this.fileList)
            if (errMsg) {
              this.$message.error(errObj.errorMessage || this.pageText.UploadFailedPleaseTryAgain)
            }
          }
        } else {
          if (errObj.code === -600) {
            if (errObj.file.size === 0) {
              this.$message.error(this.pageText.FileSelectionPleaseReselectMinimumSupportUploading)
            } else {
              this.$message.error(`${this.pageText.FileSelectionPleaseReselectMaximumSupportUploading}${this.maxFileSize.toUpperCase()}${this.pageText.heSizeOfTheFile}`)
            }
          } else if (errObj.code === -601) {
            if (this.accept) {
              this.$message.error(`${this.pageText.FileSelectionErrorPleaseReselectOnlySupport}${this.accept}${this.pageText.TypeOfFile}`)
            } else {
              this.$message.error(`${this.pageText.FileSelectionErrorPleaseReselect}`)
            }
          } else if (errObj.code === -602) {
            this.$message.error(`${this.pageText.FileSelectionErrorAlreadyExists} "${errObj.file.name}" ${this.pageText.file}`)
          } else {
            this.$message.error(this.pageText.UploadFailedPleaseTryAgain)
          }
        }
      },
      handleRemove (file) {
        let doRemove = () => {
          // 上传中的文件，暂停上传并删除文件
          if (file.status === 'uploading') {
            // this.uploader.stop()
            this.uploader.removeFile(this.uploader.getFile(file.id))
          }
          const fileList = this.fileList
          const fileIndex = fileList.findIndex(item => item.uid === file.uid)
          const fileIdIndex = fileList.findIndex(item => item.id === file.id)
          fileList.splice(fileIndex, 1)
          if (file.id) {
            this.uploadFileInfos.splice(fileIdIndex, 1)
          }
          // this.uploadFileInfos.splice(fileIndex, 1)
          // if (this.fileList.length) this.fileList.splice(fileIndex, 1)
          // console.log(this.fileList)
          this.onRemove(file, fileList)
        }
        if (!this.beforeRemove) {
          doRemove()
        } else if (typeof this.beforeRemove === 'function') {
          const before = this.beforeRemove(file, this.fileList)
          if (before && before.then) {
            before.then(() => {
              doRemove()
            }, noop)
          } else if (before !== false) {
            doRemove()
          }
        }
      },
      // 取消上传
      handleCancel (file) {
        this.handleRemove(file)
        // this.uploader.stop()
        // if (file.status === 'uploading') {
        //     // this.uploader.stop()
        //     this.uploader.removeFile(this.uploader.getFile(file.id))
        //   }
        // this.uploader.removeFile(this.uploader.getFile(file.id))
        // const fileList = this.fileList
        // const fileIndex = fileList.findIndex(item => item.uid === file.uid)
        // fileList.splice(fileIndex, 1)
        // if (file.id) {
        //   this.uploadFileInfos.splice(fileList.findIndex(item => item.id === file.id), 1)
        // }
        // this.onRemove(file, fileList)
      },
      clearFiles () {
        this.fileList = []
      },
      submit () {
        this.fileList
          .filter(file => file.status === 'ready')
          .map(file => this._upload(file))
        this.uploader.start()
      },
      async _uploadFiles (up, fileList) {
        // 最大允许上传判断
        if (this.limit && this.fileList.length + fileList.length > this.limit) {
          this.onExceed && this.onExceed(fileList, this.fileList)
          fileList.forEach(rawFile => up.removeFile(rawFile))
          this.$message.error(`${this.pageText.MaximumAllowedUpload}${this.limit}${this.pageText.mainFile}`)
          return
        }

        const batchInitFiles = []
        fileList.forEach(async (rawFile, index) => {
          rawFile.uid = Date.now() + this.tempIndex++
          const file = {
            status: 'ready',
            name: rawFile.name,
            size: rawFile.size,
            percentage: 0,
            id: rawFile.id,
            uid: rawFile.uid,
            raw: rawFile,
            type: rawFile.type
          }
          // 如果是图片  支持预览
          if ((this.listType === 'picture-card' || this.listType === 'picture') && /image\//.test(rawFile.type)) {
            try {
              if (file.type === 'image/gif' || file.type === 'image/bmp') { // gif使用FileReader进行预览,因为mOxie.Image只支持jpg和png
                let fr = new plupload.moxie.file.FileReader()
                fr.onload = function () {
                  file.url = fr.result
                  fr.destroy()
                  fr = null
                }
                fr.readAsDataURL(rawFile.getSource())
              } else {
                let preloader = new plupload.moxie.image.Image()
                preloader.onload = () => {
                  file.url = preloader.type === 'image/jpeg' ? preloader.getAsDataURL('image/jpeg', 80) : preloader.getAsDataURL()
                  preloader.destroy()
                  preloader = null
                }
                preloader.load(rawFile.getSource())
              }
            } catch (err) {
              console.error(err)
            }
          }
          // 初始化上传
          if (this.isChunk) {
            batchInitFiles.push(file)
          } else {
            this.fileList.push(file)
            this.onChange(file, this.fileList)
            if (this.autoUpload) up.start()
          }
        })
        if (this.isChunk) {
          this._uploadBatchInit(batchInitFiles)
        }
      },
      // 批量init
      async _uploadBatchInit (files) {
        const api = uploadApi.uploadBatchInit
        const params = files.map(file => {
          return {
            system: this.system,
            originalName: file.name,
            userinfo: this.userinfo,
            business: this.business,
            fileSize: file.size,
            inZipMaxSize: this.sizeConvert,
            type: this.fileType.toLowerCase(),
            checkRule: this.checkRule,
            permission: this.permission
          }
        })
        const { data } = await axios.post(`${window.fe.baseUrl}/${api.url}`, params, {
          headers: {
            test: true
          }
        })
        const up = this.uploader
        if (data.success) {
          const tokenList = data.content
          // 设置文件分片大小
          // const partSize = data.content && data.content.partSize ? data.content.partSize : 1048576

          await Promise.all(files.map(async (file, idx) => {
            this.fileList.push(file)
            // const md5s = await this._chunkFileMd5(up.getFile(file.id).getNative(), data.content[idx].partSize)
            up.setOption('chunk_size', data.content[idx].partSize)
            this.uploadFileInfos.push({id: file.id, name: file.name, token: tokenList[idx].token})
          }))

          if (this.autoUpload) up.start()
        } else {
          // 初始化失败，删除队列中文件
          up.splice(0, files.length)
          this.$message.error(`${this.pageText.UploadInitializationFailed}${data.errorMessage}`)
        }
      },
      _upload (file) {
        let before = null
        if (this.beforeUpload) {
          before = this.beforeUpload(file)
          if (before === false) {
            this.uploader.stop()
            this.uploader.removeFile(file)
            this.fileList.splice(file, 1)
          }
        }
      },
      _initUploader () {
        const self = this
        const chunkUploadUrl = uploadApi.upload.url
        self.uploader = new plupload.Uploader({
          browse_button: self.selectFileId,
          // url: self.isChunk ? `http://172.26.108.113:8052/${chunkUploadUrl}` : self.action,  // http://172.26.108.113:8052/
          url: self.isChunk ? `${window.fe.baseUrl}/${chunkUploadUrl}` : self.action,
          // url: self.action,
          runtimes: 'html5, flash, silverlight, html4',
          // 是否上传多文件
          multi_selection: self.multiple,
          // 是否启用拖拽
          dragdrop: false,
          // 文件上传名称
          file_data_name: self.name,
          // 切片大小
          chunk_size: self.isChunk ? '1mb' : 0,
          // 上传携带参数
          multipart_params: self.data,
          headers: Object.assign({
            Accept: '*/*'
          }, self.headers),
          // HTTP_ERROR错误时的重试次数
          max_retries: 2,
          container: document.getElementById(self.containerId),
          // flash上传组件地址
          flash_swf_url: FLASH_URL,
          // silverlight上传组件地址
          silverlight_xap_url: SILVERLIGHT_URL,
          filters: {
            max_file_size: this.maxFileSize,
            mime_types: this.accept ? [{ title: 'accept', extensions: self.accept.replace(/(\s|\.)*/g, '') }] : []
          },
          init: {
            PostInit (up) {
              if (self.listType === 'picture' || self.listType === 'picture-card') {
                self.autoUpload = true
              }
            },
            FilesAdded: self.handleChange.bind(self),
            // 上传进度
            UploadProgress: self.handleUploadProgress.bind(self),
            // 文件上传完成
            FileUploaded: self.handleUploadSuccess.bind(self),
            // 文件上传失败
            Error: self.handleUploadError.bind(self),
            BeforeUpload: (up, file) => {
              if (self.isChunk) {
                // 获取当前文件token
                const item = this.uploadFileInfos.find(rawFile => file.id === rawFile.id)
                if (item) {
                  up.setOption('headers', { token: item.token })
                }
              }
              // this.fileList.map(rawFile => {
              //   console.log(rawFile)
              // })
              self._upload(this.fileList.find(rawFile => rawFile.id === file.id))
            },
            ChunkUploaded: function (up, file, res) {
              const result = JSON.parse(res.response)
              if (!result.success) {
                // self.$message.error(result.errorMessage)
                // up.stop()
                // up.removeFile(up.getFile(file.id))
                // const fileList = self.fileList
                // const fileIndex = fileList.findIndex(item => item.uid === file.uid)
                // fileList.splice(fileIndex, 1)
                // if (file.id) {
                //   self.uploadFileInfos.splice(fileList.findIndex(item => item.id === file.id), 1)
                // }
                // self.onRemove(file, fileList)
                return false
              }
              if (file.size === res.offset) return false
              // const { md5 } = self.uploadFileInfos.find(f => f.name === file.name).md5
              //   .find(item => item.offset === res.offset)
              // up.setOption('multipart_params', { partMd5: md5 })
            }
          }
        })
        if (this.disabled) {
          this.uploader.disableBrowse(self.disabled)
        } else {
          this.uploader.init()
        }
      },
      _getFile (rawFile) {
        let fileList = this.fileList
        let target
        fileList.every(item => {
          target = rawFile.id === item.id ? item : null
          return !target
        })
        return target
      },
      // 分片md5加密
      // _chunkFileMd5 (file, chunkSize = 1048576) {
      //   return new Promise((resolve, reject) => {
      //     let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      //     // let chunkSize = 1048576 // Read in chunks of 1MB
      //     let chunks = Math.ceil(file.size / chunkSize)
      //     let currentChunk = 0
      //     let spark = new SparkMD5.ArrayBuffer()
      //     let fileReader = new FileReader()
      //     let chunkFileMd5s = []
      //     fileReader.onload = (e) => {
      //       spark.append(e.target.result)
      //       let blockMd5 = spark.end()
      //       chunkFileMd5s.push({ md5: blockMd5, offset: currentChunk * chunkSize })
      //       currentChunk++
      //       if (currentChunk < chunks) {
      //         loadNext()
      //       }
      //       resolve(chunkFileMd5s)
      //     }
      //     // fileReader.onerror = function () {
      //     //   reject('oops, something went wrong.')
      //     // }
      //     const loadNext = () => {
      //       let start = currentChunk * chunkSize
      //       let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
      //       fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      //     }
      //     loadNext()
      //   })
      // },
      // 上传完成
      async _complete (token, file) {
        const api = uploadApi.complete
        const params = {
          originalName: file.name
        }
        const { data } = await axios.post(`${window.fe.baseUrl}/${api.url}`, qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'token': token
          }
        })
        if (data.code === 'success' && data.success) {
          return data
        } else {
          this.handleUploadError(this.uploader, {
            file: file,
            code: -200,
            response: data,
            errorMessage: data.errorMessage
          })
          return false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
// .uploader {
//   /*width: 100%;*/
//   /*max-width: 550px;*/
// }
.uploader .sy-upload-trigger {
  display: inline-block;
}
.uploader .sy-upload--picture-card {
  text-align: center;
  border: 1px solid #EEEEEE;
  display: inline-block;
  background: #fff;
  margin-right: 8px;
  &:hover {
    border-color: #3072F3;
    cursor: pointer;
  }
  .el-icon-plus {
    font-size: 18px;
    color: #999;
  }
}
.uploader .sy-upload--picture-card-disabled {
  cursor: not-allowed;
  background: #F2F2F2;
  border: 1px solid #EEEEEE;
  &:hover {
    border-color: #EEEEEE;
    cursor: not-allowed;
  }
}
</style>
<style lang="scss">
// .uploader input[type="file"] {
//   display: none;
// }
// .uploader .el-upload-list--picture-card li {
//   position: relative;
//   z-index: 10;
// }
// .uploader .el-upload-list__item-delete {
//   vertical-align: initial;
// }

</style>
